import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-linkedin-callback-manual',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './linkedin-callback-manual.component.html',
  styleUrl: './linkedin-callback-manual.component.scss'
})
export class LinkedinCallbackManualComponent {

  isTokenValid: boolean | null = null;
  accessToken = document.cookie.split('; ').find(row => row.startsWith('access_token='))?.split('=')[1];

  constructor(private http: HttpClient, private router: Router) {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window?.location?.search);
      const code = urlParams.get('code');
      if (code) {
        this.verifyCode(code);
      } else {
        this.isTokenValid = false;
      }
    }
  }  

  verifyCode(code: string) {

    const referredBy = document.cookie.split('; ').find(row => row.startsWith('referredBy='))?.split('=')[1];
    const name = document.cookie.split('; ').find(row => row.startsWith('name='))?.split('=')[1];
    const phone = document.cookie.split('; ').find(row => row.startsWith('phone='))?.split('=')[1];
    const requestBody: any = { code: code };
    if (referredBy) {
      requestBody.referredBy = referredBy;
    }
    if (name) {
      requestBody.name = name;
    }
    if (phone) {
      requestBody.phone = phone;
    }
    
    this.http.post(`${environment.url}/api/linkedin/verification`, requestBody, {headers: 
      {
          'Content-Type': 'application/json', // Set content type to JSON
          'Authorization': `Bearer ${this.accessToken}` // Use access token as authorization header
      }})
      .pipe(
        catchError(() => of(false))
      )
      .subscribe((response: any) => {
        if (response) {
          this.router.navigate(['/session/candidate-profiling-success']);
        } else {
          this.isTokenValid = false;
        }
      });
  }

  continueRegister() {
    this.router.navigate(['/session/candidate-profiling']);
  }


}
